export default __webpack_public_path__ + "static/bncff-web-site-2-b308a6a4895d299f0958fd6a3ed18d6b.jpg";